import React, { lazy } from 'react';
import ElectronBlankSreenIcon from '@/assets/images/menu/icon-electron-blank-screen.react.svg?react';
import ElectronSessionIcon from '@/assets/images/menu/icon-electron-session.react.svg?react';
import ElectronApiIcon from '@/assets/images/menu/icon-hippy-api.react.svg?react';
import ElectronErrorIcon from '@/assets/images/menu/icon-hippy-error.react.svg?react';
import ElectronEventIcon from '@/assets/images/menu/icon-hippy-event.react.svg?react';
import ElectronLogIcon from '@/assets/images/menu/icon-hippy-log.react.svg?react';
import ElectronPerfIcon from '@/assets/images/menu/icon-hippy-perf.react.svg?react';
import ElectronPvIcon from '@/assets/images/menu/icon-hippy-pv.react.svg?react';
import ElectronSpeedIcon from '@/assets/images/menu/icon-hippy-speed.react.svg?react';
import ElectronStaticIcon from '@/assets/images/menu/icon-hippy-static.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const electronRoutes = (): IRouteConfig[] => [
  {
    path: '/electron/error',
    name: '错误监控',
    component: lazy(() => import('@/presentation/pages/electron/error')),
    icon: <MenuIcon icon={ElectronErrorIcon} fontSize={16} />,
    platforms: [CapitalPlatform.Electron],
  },
  {
    path: '/electron/api',
    name: 'API监控',
    icon: <MenuIcon icon={ElectronApiIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/electron/api')),
    platforms: [CapitalPlatform.Electron],
  },
  {
    path: '/performance',
    name: '性能监控',
    icon: <MenuIcon icon={ElectronPerfIcon} fontSize={16} />,
    platforms: [CapitalPlatform.Electron],
    routes: [
      {
        path: '/electron/browser',
        name: '主进程性能',
        component: lazy(() => import('@/presentation/pages/electron/browser')),
      },
      {
        path: '/electron/perf',
        name: '页面性能',
        component: lazy(() => import('@/presentation/pages/electron/perf')),
      },
      {
        path: '/electron/load',
        name: '页面加载',
        component: lazy(() => import('@/presentation/pages/electron/load')),
      },
    ],
  },
  {
    path: '/electron/blank-screen',
    name: '白屏检测',
    icon: <MenuIcon icon={ElectronBlankSreenIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/electron/blank-screen')),
    platforms: [CapitalPlatform.Electron],
  },
  {
    path: '/electron/pv',
    name: '页面访问',
    icon: <MenuIcon icon={ElectronPvIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/electron/pv')),
    platforms: [CapitalPlatform.Electron],
  },
  {
    path: '/electron/static',
    name: '静态资源',
    icon: <MenuIcon icon={ElectronStaticIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/electron/static')),
    platforms: [CapitalPlatform.Electron],
  },
  {
    path: '/electron/session/detail',
    name: '会话详情',
    component: lazy(() => import('@/presentation/pages/electron/session/detail')),
    hideInMenu: true,
    platforms: [CapitalPlatform.Electron],
  },
  {
    path: '/electron/session',
    name: '会话追踪',
    icon: <MenuIcon icon={ElectronSessionIcon} fontSize={16} />,
    platforms: [CapitalPlatform.Electron],
    component: lazy(() => import('@/presentation/pages/electron/session')),
    // routes: [
    //   {
    //     path: '/electron/session/overview',
    //     name: '会话概览',
    //     component: lazy(() => import('@/presentation/pages/electron/session')),
    //   },
    //   {
    //     path: '/electron/session/selector',
    //     name: '会话测试',
    //     component: lazy(() => import('@/presentation/pages/electron/session/selector-test')),
    //     hideInMenu: true,
    //   },
    //   {
    //     path: '/electron/session/detail',
    //     name: '会话详情',
    //     component: lazy(() => import('@/presentation/pages/electron/session/detail')),
    //     hideInMenu: true,
    //   },
    // ],
  },
  {
    path: '/electron/event',
    name: '自定义事件',
    platforms: [CapitalPlatform.Electron],
    icon: <MenuIcon icon={ElectronEventIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/electron/event')),
  },
  {
    path: '/electron/custom',
    name: '自定义测速',
    platforms: [CapitalPlatform.Electron],
    icon: <MenuIcon icon={ElectronSpeedIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/electron/custom')),
  },
  {
    path: '/electron/log',
    name: '日志',
    platforms: [CapitalPlatform.Electron],
    component: lazy(() => import('@/presentation/pages/electron/log')),
    icon: <MenuIcon icon={ElectronLogIcon} fontSize={16} />,
  },
];

export default electronRoutes;
